import script from "./SearchbarMolecule.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchbarMolecule.vue?vue&type=script&setup=true&lang=ts"

import "./SearchbarMolecule.css?vue&type=style&index=0&id=2d6d23ea&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d6d23ea"]])

export default __exports__